import { connect } from 'react-redux';
import { showReportModal } from '../../../../Moderation/redux/actions';
import { shareDeviationToPost, unpublishDeviation } from '../../../../redux/deviations/actionCreators';
const mapStateToProps = ()=>({});
const mapDispatchToProps = {
    showReportModal,
    shareDeviationToPost,
    unpublishDeviation
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=MoreMenuMobileDropdown.container.js.map